// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/task/v1/binding.proto" (package "c1.api.task.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { TaskBindingService } from "./binding";
import type { CountRelatedTasksResponse } from "./binding";
import type { CountRelatedTasksRequest } from "./binding";
import type { ListRelatedTasksResponse } from "./binding";
import type { ListRelatedTasksRequest } from "./binding";
import type { TaskBindingServiceListByReferenceTaskRequest } from "./binding";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { TaskBindingServiceListResponse } from "./binding";
import type { TaskBindingServiceListRequest } from "./binding";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.task.v1.TaskBindingService
 */
export interface ITaskBindingServiceClient {
    /**
     * @generated from protobuf rpc: List
     */
    list(input: TaskBindingServiceListRequest, options?: RpcOptions): UnaryCall<TaskBindingServiceListRequest, TaskBindingServiceListResponse>;
    /**
     * @generated from protobuf rpc: ListByReferenceTask
     */
    listByReferenceTask(input: TaskBindingServiceListByReferenceTaskRequest, options?: RpcOptions): UnaryCall<TaskBindingServiceListByReferenceTaskRequest, TaskBindingServiceListResponse>;
    /**
     * @generated from protobuf rpc: ListRelatedTasks
     */
    listRelatedTasks(input: ListRelatedTasksRequest, options?: RpcOptions): UnaryCall<ListRelatedTasksRequest, ListRelatedTasksResponse>;
    /**
     * @generated from protobuf rpc: CountRelatedTasks
     */
    countRelatedTasks(input: CountRelatedTasksRequest, options?: RpcOptions): UnaryCall<CountRelatedTasksRequest, CountRelatedTasksResponse>;
}
/**
 * @generated from protobuf service c1.api.task.v1.TaskBindingService
 */
export class TaskBindingServiceClient implements ITaskBindingServiceClient, ServiceInfo {
    typeName = TaskBindingService.typeName;
    methods = TaskBindingService.methods;
    options = TaskBindingService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: List
     */
    list(input: TaskBindingServiceListRequest, options?: RpcOptions): UnaryCall<TaskBindingServiceListRequest, TaskBindingServiceListResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskBindingServiceListRequest, TaskBindingServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListByReferenceTask
     */
    listByReferenceTask(input: TaskBindingServiceListByReferenceTaskRequest, options?: RpcOptions): UnaryCall<TaskBindingServiceListByReferenceTaskRequest, TaskBindingServiceListResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskBindingServiceListByReferenceTaskRequest, TaskBindingServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListRelatedTasks
     */
    listRelatedTasks(input: ListRelatedTasksRequest, options?: RpcOptions): UnaryCall<ListRelatedTasksRequest, ListRelatedTasksResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListRelatedTasksRequest, ListRelatedTasksResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CountRelatedTasks
     */
    countRelatedTasks(input: CountRelatedTasksRequest, options?: RpcOptions): UnaryCall<CountRelatedTasksRequest, CountRelatedTasksResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<CountRelatedTasksRequest, CountRelatedTasksResponse>("unary", this._transport, method, opt, input);
    }
}
